import { connect } from 'react-redux';
import { updateGroupCohortsByOrganizationType } from 'actions/partner';
import {
  enqueueGroupCohortsCSVReport,
} from 'actions/groupCohortsOrganizationType';
import { showReportDetailsModal } from 'actions/internal';
import { getLoaders } from 'selectors';
import GroupCohortsByOrganizationTypeFilter from 'components/filters/GroupCohortsByOrganizationTypeFilter';
import _ from 'lodash';

const mapStateToProps = (state) => {
  return {
    meta: state.meta.groupCohortsByOrganizationType,
    csvReport: state.groupCohortsOrganizationTypeCSVReport,
    withScope: state.filters.withScope,
    organizationTypes: state.filters.organizationTypes,
    periods: state.filters.periods,
    isLoading: getLoaders(state, ['REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE_FILTER_REQUEST', 'REPORT_GROUP_COHORT_BY_ORGANIZATION_TYPE']),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onWithAgesChange: (withages) => {
      dispatch(updateGroupCohortsByOrganizationType({withages, page: 1}))
    },
    // Unlike withages, the ASQ columns are not already in the payload, so this
    // has to go back to the server rather than just toggling visibility.
    onWithAsqResultsChange: (withasq) => {
      dispatch(updateGroupCohortsByOrganizationType({withasq, page: 1}));
    },
    onOrganizationTypeChange: (organizationTypes) => {
      dispatch(updateGroupCohortsByOrganizationType({organizationTypes, page: 1}));
    },
    onPeriodChange: (start, end) => {
      dispatch(updateGroupCohortsByOrganizationType({start, end, page: 1}));
    },
    onCSVEnqueue: _.debounce(() => {
      dispatch(enqueueGroupCohortsCSVReport());
    }, 500),
    onCSVReportDetailsShow: (report) => {
      dispatch(showReportDetailsModal(report, 'GROUP_COHORTS_ORGANIZATION_TYPE_REPORT_DETAILS'));
    },
  }
}

const GroupCohortsFilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupCohortsByOrganizationTypeFilter)

export default GroupCohortsFilterContainer;
